import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ehm9uwt6f: FaireProductEntity = {
  token: "p_7ehm9uwt6f",
  type: "product",
  name: "True Life Peach Juice Drink - 12/500mL",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/68f4eba818b36bafcc871b3de06f489d322225e579b40722921c699c9299967f.png",
  galleryImageUrls: [],
  priceDollars: 24.94,
  description:
    "True Life Peach Juice Drink captures the juicy, mellow sweetness of ripe peaches in a smooth, refreshing blend. With English and Spanish labeling, it’s perfect for bilingual markets. A deliciously fruity choice your customers will enjoy!",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:49.845Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
